import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  minNiche: {
    defaultValue: 'Pelo menos um nicho deve estar selecionado',
    key: 'industry-category-niche-tab-minNiche',
  },
  emptyStateTitle: {
    defaultValue: 'Não encontramos nichos para este contexto.',
    key: 'industry-category-niche-tab-emptyStateTitle',
  },
  emptyStateDescription: {
    defaultValue: 'Por enquanto este contexto não possui nichos relacionados a ele.',
    key: 'industry-category-niche-tab-emptyStateDescription',
  },
  createReport: {
    defaultValue: 'Criar report',
    key: 'industry-category-niche-tab-createReport',
  },
  compareThemes: {
    defaultValue: 'Comparar temas',
    key: 'industry-category-niche-tab-compareThemes',
  },
  emptyContexts: {
    defaultValue: 'Por enquanto este território não possui contextos relacionados a ele',
    key: 'industry-category-niche-tab-emptyContexts',
  },
})
